export enum DigitalSignatureType {
  DigitalSignature = 'digital-signature',
  DigitalSignatureEmail = 'digital-signature-email',
  DigitalSignatureBrowser = 'digital-signature-browser',
}
